// extracted by mini-css-extract-plugin
export var gif = "_ef-0";